import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Flex, Table, message, Tooltip, Avatar } from "antd";
import { useNavigate } from "react-router-dom";
import {
  CustomParagraph,
  CustomTitle,
  AddItemButton,
  CustomModalWithoutButton,
} from "../../components/index.js";
import { useToken } from "../../common/helper/index.js";
import { courier, fetchAllCouriers } from "../../reudx-toolkit/slice/onboardingSlice";
import { useSpin } from "../../components/SpinContext.js";
import deleteIcon from "../../assets/images/delete.svg";
import editIcon from "../../assets/images/edit-gray-icon.svg";
import mailIcon from "../../assets/images/mail.svg";
import phoneIcon from "../../assets/images/phone.svg";
import CommonDrawer from "../../components/CommonDrawer.jsx";
import CustomDeleteModal from "../Modals/CustomDeleteModal.jsx";
import TeamsTag from "../../components/TeamsTag.jsx";
import { useSelector } from "react-redux";
import StatusTag from "../../components/StatusTag.jsx";
import TransportProviderForm from "./TransportProviderForm.jsx";
import ProviderDetails from "./TransportProviderDetails.jsx";
import TransportConnectionModal from "../Modals/TransportConnectionModal.jsx";
import { getCompanyCouriersDDL, getTeamsDDL } from "../../common/utils/dropDown.js";
import { DeleteCourierAccount, DeleteProduct } from "../../api's/onboarding.js";
import { GetSettingsNewCouriers } from "../../api's/settings.js";
import TeamBadge from "../../components/TeamBadge.jsx";
import { getProviderImagePath } from "../../common/utils/imageUtils";
import ZLShield from '../../assets/images/ZLshield.png';
import Arrows from '../../assets/images/arrows.png';
import { getPermissions } from "../../common/helper/getPermissions.js";
import { DeleteSettingsCourierAccount } from "../../api's/onboarding.js";
import { selectCouriersState } from "../../reudx-toolkit/slice/onboardingSlice";
import { InstagramOutlined } from "@ant-design/icons";


const TransportProviders = ({ title }) => {
  const { token, removeToken } = useToken();
  const navigate = useNavigate();
  const [showProviderDetails, setShowProviderDetails] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const allTeams = useSelector((state) => state.teams.list);
  const [searchQuery, setSearchQuery] = useState("");
  const { showSpin, hideSpin } = useSpin();
  const [providersList, setProvidersList] = useState([]);
  const [couriersList, setCouriersList] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [recordId,setRecordID]= useState(null);
  const [courierID,setCourierID]= useState(null);
  const [modalState, setModalState] = useState({
    delete: false,
    connection: false,
  });
  const main_menu = useSelector((state) => state.menu.items);
  const CouriersPermissions = getPermissions(main_menu, "Settings", "Transport providers");

  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const dispatch = useDispatch();
  const { courierList, status } = useSelector(selectCouriersState);

  // useEffect(() => {
  //   getCompanyCouriersDDL(token).then((val) => {
  //     if (val && val.length > 0) {
  //       setCouriersList(val);
  //     }
  //   });
  // }, []);

  //fetch all couriers
  const GetAllCouriers = () => {
    showSpin();
    GetSettingsNewCouriers(token)
      .then((res) => {
        const data = res?.data || null;
        if (data) {
          if (data.data?.is_success) {
            if (data?.data?.data?.couriers && data?.data?.data?.couriers?.length > 0) {
              setProvidersList(data?.data?.data?.couriers);
            } else {
              setProvidersList([])
            }
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      }).finally(() => {
        hideSpin();
      });

  };


  useEffect(() => {
    GetAllCouriers();

  }, []);

  const handleDeleteClick = (record) => {
    setRecordID(record.id);
    setDeleteModalVisible(true);

  };


  const unauthorize = (status) => {
    if (status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  const handleConfirmDelete = () => {
   // if (!selectedProvider) return;
    showSpin();
    // setTimeout(() => {
    //   message.success("Transport provider removed successfully");
    //   setProvidersList((prev) =>
    //     prev.filter((prov) => prov.id !== selectedProvider.id)
    //   );
    //   hideSpin();
    //   setDeleteModalVisible(false);
    // }, 1000);

    setDeleteModalVisible(false);
    setDrawerOpen(false);
    setModalState((prev) => ({ ...prev, delete: false }));

    if (recordId) {
      showSpin();
      DeleteCourierAccount(recordId, token)
        .then((res) => {
          const data = res?.data || null;
          if (data) {
            if (data.data?.is_success) {
              message.success(data?.data?.message);
              setSelectedProvider(null);
              GetAllCouriers();
            } else {
              message.error(data?.data?.message);
            }
          }
        })
        .catch((error) => {
          unauthorize(error);
        })
        .finally(() => {
          hideSpin();
        });
    }
  };


  const handleEdit = (record) => {
    
    let instruction = "";
    if(record && !record?.instructions){
      instruction = courierList.find(x=>x.id === record?.courier_id).instructions
      record = {... record,instructions:instruction}
    }
    setSelectedProvider(record);
    setShowProviderDetails(true);
    setIsEditing(true);
    setDrawerOpen(true);
    setRecordID(record?.id ? record?.id : null)
    setCourierID(record?.courier_id ? record?.courier_id : null)
  };

  const handleCloseDrawer = () => {
    setModalOpen(false);
    setDrawerOpen(false);
    setSelectedProvider(null);
    setShowProviderDetails(false);
    setSearchQuery("");
    GetAllCouriers();
  };


  const onModalConfirm = (data) => {
    setModalOpen(false);
    setModalState((prev) => ({ ...prev, connection: false }));

    // console.log('on confirm :' , data)
    // console.log("Selected Provider in ProviderDetails:", selectedProvider);

    //dispatch(fetchAllCouriers(token));
    setSelectedProvider((prev) => ({ ...prev, ...data }))
    setShowProviderDetails(true);
  };

  const handleAddProvider = () => {
    setSelectedProvider(null);
    setIsEditing(false);
    setShowProviderDetails(false);
    setDrawerOpen(true);
  };

  const columns = [
    {
      title: "Provider",
      dataIndex: "courier_name",
      width: 150,
      key: "courier_name",
      render: (text) => (
        <div>
        <CustomParagraph
          noText="--"
          text={text}
          fontSize={12}
          fontWeight={600}
          color="#000"
        />
        </div>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      width: 250,
      key: "description",
      render: (text) => (
        <div>
        <CustomParagraph
          noText="--"
          text={text}
          fontSize={14}
          fontWeight={400}
          color="#000"
        />
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 250,
      key: "status",
      render: (status, record) => (
        <div>
        <StatusTag status={status} />
        </div>
      ),
    },
    {
      title: "Team",
      width: 350,
      dataIndex: "teams",
      key: "teams",

      render: (_, record) => {
        return (
          <div style={{ maxWidth: 200 }}>
          {record?.teams?.length > 0 ? (
            <div style={{ display: "flex", gap: "8px", flexWrap: "nowrap" }}>
              <TeamBadge
                color={record?.teams[0]?.color}
                text={record?.teams[0]?.name}
                tooltipText={record?.teams[0]?.name}
              />
              {record?.teams.length > 1 && (
                <Tooltip
                  title={record.teams.slice(1).map((team) => team.name).join(", ")}
                  placement="top"
                >
                  <div style={{ display: "inline-block", cursor: "pointer" }}>
                    <TeamBadge color={null} text={`+ ${record?.teams.length - 1}`} />
                  </div>
                </Tooltip>
              )}
            </div>
          ) : (
            <div>--</div>
          )}
        </div>
        
        );
      },
    },
    {
      title: "Primary contact",
      dataIndex: "contact",
      width: 250,
      key: "contact",
      render: (contact) => {
        const primaryContact = contact?.find((c) => c.is_primary_contact);

        return (
          <div>
          <Flex gap={8} align="center">
            {primaryContact ? (
              <>
                <CustomParagraph
                  text={primaryContact?.name}
                  fontSize={14}
                  fontWeight={400}
                  color="#000"
                />
                <div style={{ marginBottom: "0px" }}>
                  <Tooltip title={primaryContact?.phone_number}>
                    <img
                      src={phoneIcon}
                      alt="Phone"
                      style={{
                        width: "12px",
                        height: "12px",
                        marginRight: "5px",
                        cursor: "pointer",
                      }}
                    />
                  </Tooltip>

                  <Tooltip title={primaryContact?.email}>
                    <img
                      src={mailIcon}
                      alt="Mail"
                      style={{ width: "12px", height: "12px", cursor: "pointer" }}
                    />
                  </Tooltip>
                </div>
              </>
            ) : (
              <CustomParagraph text="--" fontSize={12} color="#888" />
            )}
          </Flex>
          </div>
        );
      },
    },

    {
      title: "",
      key: "action",
      render: (_, record) => (
        <Flex>
          <Flex
            justify="center"
            align="center"
            style={{ width: "42px", gap: "30px", cursor: "pointer" }}
          >
          {record?.permissions?.is_update &&
           <img src={editIcon} alt="Edit" onClick={() => handleEdit(record)} />
          }
         {record?.permissions?.is_delete &&
            <img src={deleteIcon} alt="Delete" onClick={() => handleDeleteClick(record)}/>
         }
            </Flex>
        </Flex>
      ),
    },
  ];


  const handleProviderSelect = (provider) => {
    setCourierID(provider?.id)
    setSelectedProvider(provider);
  };

 


  const TeamsFilteredColumns =
    allTeams?.length > 0
      ? columns
      : columns.filter((column) => column.key !== "teams");


  return (
    <>
      <div className="settings-content-wrapper">
        {/* <Flex justify="space-between" align="center"> */}
        <CustomTitle
          text={`${title} (${providersList.length})`}
          fontSize={20}
          fontWeight="700"
          lineHeight="32px"
          color="#000"
          marginBottom={0}
        />
        {/* </Flex> */}

        {/* <Flex vertical={true} gap={32}> */}
        <Table
          columns={TeamsFilteredColumns}
          dataSource={providersList}
          pagination={false}
          className="settings-table transport-provider-table"
        />
        {CouriersPermissions?.is_create &&
        <AddItemButton
          marginTop="0px"
          fontSize="12px"
          fontWeight="600"
          color="#000"
          text={"Add transport provider"}
          onClick={handleAddProvider}
        />}
        {/* </Flex> */}
      </div>
      <CustomDeleteModal
        visible={deleteModalVisible || modalState.delete}
        onClose={() => {
          setDeleteModalVisible(false);
          setModalState((prev) => ({ ...prev, delete: false }));
        }}
        onConfirm={handleConfirmDelete}
        title={
          modalState.delete
            ? `Remove ${selectedProvider?.title || selectedProvider?.courier_name} Connection`
            : "Remove Transport Provider"
        }
        message={
          modalState.delete
            ? "This transport provider is used in active shipments now. Complete active shipments to enable remove action."
            : "Removing this provider will prevent selecting it for future use."
        }
        cancelText="Cancel"
        confirmText="Remove"
        confirmColor="#DE1135"
      />

      <CommonDrawer open={drawerOpen} onClose={handleCloseDrawer}>
        {showProviderDetails ? (
          <ProviderDetails
            title='provider'
            setModalState={setModalState}
            providerData={selectedProvider}
            onClose={handleCloseDrawer}
            edit={isEditing}
            recordId={recordId}
            courierId={courierID}
          />
        ) : (
          <TransportProviderForm
            selectedProvider={selectedProvider}
            setSelectedProvider={handleProviderSelect}
            modalOpen={modalOpen}
            setModalOpen={setModalOpen}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            showProviderDetails={showProviderDetails}
            setShowProviderDetails={setShowProviderDetails}
            token={token}
            onClose={handleCloseDrawer}
          />
        )}
      </CommonDrawer>


      {modalState.connection || modalOpen ? (
        <CustomModalWithoutButton
          modalOpen={modalOpen || modalState.connection}
          setModalOpen={() => {

            setModalOpen(false);
            setModalState((prev) => ({ ...prev, connection: false }));
          }}
          modalTitle={`Connect to ${selectedProvider?.title || selectedProvider?.courier_name} for advanced tracking`}
          modalText={`By providing API access to ZoomLogi, you’re enabling ZoomLogi to retrieve your shipment information.`}
          modalSize={795}
          modalBorderRadius={"16px"}
          headerIcon={
            selectedProvider && (
              <Flex align="center" justify="center" gap={12}>
                <Avatar
                  src={<img src={getProviderImagePath(selectedProvider.title || selectedProvider?.courier_name, 'transportProvider')} alt={selectedProvider.name || selectedProvider?.courier_name} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />}
                  size={52}
                  style={{
                    backgroundColor: 'transparent',
                    boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.15)',
                    borderRadius: '50%'
                  }}
                />
                <img src={Arrows} alt="connects to" style={{ height: '40px' }} />
                <Avatar
                  size={52}
                  style={{
                    backgroundColor: 'transparent',
                    boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.15)',
                    borderRadius: '50%',
                  }}
                >
                  <div style={{ padding: '6px', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <img src={ZLShield} alt="ZoomLogi" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                  </div>
                </Avatar>
              </Flex>
            )
          }
        >
          <TransportConnectionModal
            data={selectedProvider}
            onSuccess={onModalConfirm}
          />
        </CustomModalWithoutButton>
      ): null}
    </>
  );
};

export default TransportProviders;
